<template>
  <BaseSectionSearch @submit="onSubmit" @reset="onReset">
    <v-row dense>
      <FormItem
        v-model="code"
        type="text"
        name="Codice"
        hint="Ricerca per Codice"
        :cols="3"
        dense
      />
      <FormItem
        v-model="active"
        type="select"
        :values="[
          { value: 'true', text: 'Attivo' },
          { value: 'false', text: 'Inattivo' },
        ]"
        name="Stato"
        :cols="3"
        dense
      />

      <FormItem
        v-model="macros"
        :values="macrosByContext({ category: categories })"
        type="autocomplete"
        deletable-chips
        name="Limitati alle commesse"
        dense
        :cols="3"
      />

      <FormItem
        v-model="categories"
        :values="categoriesByContext({ macro: macros })"
        type="autocomplete"
        deletable-chips
        name="Limita alle categorie"
        dense
        :cols="3"
      />
    </v-row>
  </BaseSectionSearch>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import { mapGetters, mapMutations, mapState } from 'vuex'

import BaseSectionSearch from '@components/structure/base-section-search.vue'
import FormItem from '@components/forms/FormItem.vue'

const { mapFields } = createHelpers({
  getterType: 'ticketsStatuses/getFiltersFields',
  mutationType: 'ticketsStatuses/SET_FILTER_FIELDS',
})

export default {
  name: 'TicketsStatusesSearch',
  components: { FormItem, BaseSectionSearch },
  computed: {
    ...mapFields(['active', 'macros', 'categories', 'code', 'status']),
    ...mapState('ticketsStatuses', ['filters']),
    ...mapGetters('ticketsActivities', {
      macrosByContext: 'macrosByContext',
      categoriesByContext: 'categoriesByContext',
    }),
  },
  beforeDestroy() {
    this.reset()
  },
  methods: {
    ...mapMutations('ticketsStatuses', {
      reset: 'RESET_FILTER_FIELDS',
    }),
    onSubmit() {
      this.$emit('search')
    },
    onReset() {
      this.reset()
      this.$emit('search')
    },
  },
}
</script>

<style scoped></style>
